function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import Animation from '@shared/components/animation';
import SpzaComponent from '@shared/components/spzaComponent';
import { dynamicsLicenseTypeForEmbed, setInitialLocalLicenseStore, setInitialLicenseDisplayText, isTransactApp, getTrailIdAndData, dynamicsLicenseType, readUserProfileEmbedCookie, getAppTelemetryDetailContentText, getServiceTelemetryDetailContentText, shouldDownloadPowerBIVisual, getActionStringForCTAType, isPowerBIVisualsApp, isOpenInNewWindowButton, openInNewWindow, getProductByUrlKey, generateGuid, isAzureApp, getHandoffUrl, getHandoffTitle, isPlanAbleAzureApp } from '@shared/utils/appUtils';
import { Constants, OfferType } from '@shared/utils/constants';
import { getLocalStorageItem, getCookieItem } from '@shared/utils/browserStorageUtils';
import { postEmbedAcquisitionMessage } from '@embed/embedMessaging';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { NpsModule } from '@shared/utils/npsUtils';
import { UserProfileModal } from '@appsource/containers/modals/userProfileModal';
import { isLeadgenEnabled, isETERunning } from '@shared/utils/modals';
import { urlPush, routes } from '@shared/routerHistory';
import { getNpsModule } from '@appsource/utils/nps';
import { logger } from '@src/logger';
import { Stack, Text, mergeStyleSets, PrimaryButton, Icon, ScreenWidthMinXLarge, ScreenWidthMinLarge, TextField } from '@fluentui/react';
import { NeutralColors, CommunicationColors } from '@fluentui/theme';
import { TelemetryImage } from '@shared/components/telemetryImage';
import classNames from 'classnames';
import { SuccessConsentModal } from '@appsource/components/modals/successConsentModal';
import { FailureConsentModal } from '@appsource/components/modals/failureConsentModal';
import { SafeHtmlWrapper } from '@shared/components/safeHtmlWrapper';
import { ConsentModalContent } from './consentModalContent';
import { getTooltipSilentLogIn } from '@shared/utils/silentLogInUtils';
import { useTelemetry } from '@shared/hooks/useTelemetry';
import { containsURLOrEmail } from '@shared/utils/InputValidationUtils';
import { openInNewWindowButtonStyles } from '@shared/components/contentStyles';
import { hidePowerBiVisualPricing } from '@shared/utils/pricing';
import { stringifyError } from '@shared/utils/errorUtils';
import { ConsentModalPlan } from './consentModalPlan';
import { updateHandOffUrlWithCampaignParams } from '@shared/utils/routeUtils';
// eslint-disable-next-line react-hooks/rules-of-hooks
const [{ pageAction }] = useTelemetry();
const modalStyles = {
    main: {
        [`@media (min-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '35%'
        },
        [`@media (min-width: ${ScreenWidthMinLarge}px) and (max-width: ${ScreenWidthMinXLarge}px)`]: {
            width: '60%'
        },
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            width: '90%'
        },
        display: 'flex'
    },
    scrollableContent: {
        padding: '16px 27px 24px 24px',
        [`@media (max-width: ${ScreenWidthMinLarge}px)`]: {
            padding: '16px 20px 24px 20px'
        }
    }
};
const infoIconStyles = {
    root: {
        fontSize: 16,
        marginRight: 8
    }
};
const consentModalClassNames = mergeStyleSets({
    appImg: {
        width: 44,
        height: 44,
        padding: 4,
        border: `1px solid ${NeutralColors.gray20}`
    },
    appImgContainer: {
        marginRight: 8,
        width: 44,
        height: 44
    },
    boldText: {
        fontWeight: 600
    },
    desclaimerContainer: {
        backgroundColor: NeutralColors.gray20,
        marginBottom: 20,
        marginTop: 12,
        '& a:link': {
            color: CommunicationColors.primary,
            textDecoration: 'underline'
        },
        '& a:visited': {
            color: CommunicationColors.primary
        },
        '& a:hover': {
            color: CommunicationColors.shade20
        },
        '& a:active': {
            color: CommunicationColors.shade30
        }
    },
    userProfileContainer: {
        marginBottom: 8
    },
    notes: {
        marginBottom: 8
    },
    animationImg: {
        display: 'flex',
        justifyContent: 'center'
    }
});
const loginUserInfoTokens = {
    padding: '20px 0px 4px'
};
const desclaimerTokens = {
    padding: 8
};
const animationStackTokens = {
    childrenGap: 25
};
/** These offer types should not trigger sending leads */ const offerTypesWithoutLeads = [
    Constants.PowerBI.visuals
];
export class ConsentModal extends SpzaComponent {
    isMandatoryFieldsFilled({ firstName, lastName, email, country }) {
        return !!(firstName && lastName && email && country);
    }
    telemetry(action, actionModifier, details) {
        const { trailId } = this.state;
        const { location } = this.props;
        const payload = {
            page: location === null || location === void 0 ? void 0 : location.pathname,
            action,
            actionModifier,
            details: JSON.stringify(_object_spread({
                trailId
            }, details))
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    }
    logConsentDialogEvents(action, actionModifier, details = this.getTelemetryDetailsContent()) {
        const { appInfo, serviceInfo, location } = this.props;
        const entityInfo = appInfo || serviceInfo;
        const payload = {
            page: location === null || location === void 0 ? void 0 : location.pathname,
            action,
            actionModifier,
            appName: entityInfo && entityInfo.entityId,
            details
        };
        this.instrument.probe('logAndFlushTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName
        });
    }
    setAccountInfo(consentProps) {
        const { userProfile, isEmbedded, appInfo } = consentProps;
        this.licenseType = isEmbedded ? dynamicsLicenseTypeForEmbed(appInfo.products) : appInfo ? dynamicsLicenseType(userProfile, appInfo.products) : -1;
        this.setState({
            accountInfo: {
                firstName: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.firstName) ? userProfile.firstName : '',
                lastName: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.lastName) ? userProfile.lastName : '',
                email: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.email) ? userProfile.email : '',
                title: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.title) ? userProfile.title : '',
                company: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.company) ? userProfile.company : '',
                country: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.country) ? userProfile.country : '',
                phone: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone) ? userProfile.phone : ''
            },
            localLicenseStore: (this.licenseType === Constants.Dynamics365LicenseType.dynamics365License || this.licenseType === Constants.Dynamics365LicenseType.dynamics365forBusinessLicense) && !isEmbedded ? setInitialLocalLicenseStore(userProfile.licenses, this.licenseType) : null,
            licenseDisplayText: (this.licenseType === Constants.Dynamics365LicenseType.dynamics365License || this.licenseType === Constants.Dynamics365LicenseType.dynamics365forBusinessLicense) && !isEmbedded ? setInitialLicenseDisplayText(userProfile.licenses, this.licenseType) : ''
        });
    }
    isCTAShouldSkipModal() {
        const { ctaType, isEmbedded, modal } = this.props;
        const isOpenedFromPDP = modal === null || modal === void 0 ? void 0 : modal.isOpenedFromPDP;
        const shouldCTATypeBeSkip = [
            Constants.CTAType.Get,
            Constants.CTAType.Try
        ].includes(ctaType);
        return isOpenedFromPDP && !isEmbedded && shouldCTATypeBeSkip;
    }
    /** Determines whether should skip the consent modal */ shouldSkipModal(userProfile) {
        const { isContactForm, isEmbedded, appInfo } = this.props;
        if (!appInfo) {
            return false;
        }
        if (isContactForm) {
            return false;
        }
        if (isEmbedded && isPowerBIVisualsApp(appInfo)) {
            return true;
        }
        if (isAzureApp(appInfo)) {
            return false;
        }
        return this.isCTAShouldSkipModal() && this.isMandatoryFieldsFilled(userProfile);
    }
    componentDidMount() {
        const { isTransactApp, appInfo, fetchAppDetails, fetchAppPricing, userProfile, userInfo, isContactForm, dismissModal, isEmbedded } = this.props;
        this.setState({
            isEmbeddedApp: isEmbedded && !isContactForm
        });
        if (this.shouldSkipModal(userProfile)) {
            this.logConsentDialogEvents(Constants.Telemetry.ActionModifier.ConsentModal, Constants.Telemetry.Action.Skip, JSON.stringify({
                AutomaticallyAccepted: true
            }));
            this.setState({
                shouldSkipModal: true
            });
            // Embed doesn't dismiss the modal when skipping it, so dismiss manually
            if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.signedIn) && isEmbedded) {
                dismissModal();
            }
            this.handleContinue(userProfile);
        } else if (this.isCTAShouldSkipModal() && !this.isMandatoryFieldsFilled(userProfile) && !(userInfo === null || userInfo === void 0 ? void 0 : userInfo.loading)) {
            this.logConsentDialogEvents(Constants.Telemetry.ActionModifier.ConsentModal, Constants.Telemetry.Action.Open, JSON.stringify({
                AutomaticallyAccepted: false
            }));
        } else {
            this.logConsentDialogEvents(Constants.Telemetry.ActionModifier.ConsentModal, Constants.Telemetry.Action.Open);
        }
        if (isTransactApp) {
            this.handleTransactCheckout(this.props);
        }
        if (appInfo && isPlanAbleAzureApp(appInfo) && !appInfo.pricingInformation) {
            this.setState({
                loadingPricing: true
            });
            fetchAppPricing(appInfo);
        }
        // For the privacy policy URL to show up, we need the app details.
        if (appInfo && appInfo.detailInformation == null) {
            fetchAppDetails(appInfo);
        } else if (appInfo) {
            this.setState({
                appPrivacyPolicyUrl: appInfo.detailInformation.PrivacyPolicyUrl
            });
        }
        if (userInfo.loading && !isContactForm && this.isCTAShouldSkipModal()) {
            this.setState({
                showAnimation: true
            });
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { userProfile: currentUserProfile, appInfo: currentAppInfo, isLoadingUserProfile: currentIsLoadingUserProfile } = this.props;
        const { userProfile: nextUserProfile, appInfo: nextAppInfo, userInfo: nextUserInfo, isLoadingUserProfile: nextIsLoadingUserProfile, isContactForm: nextIsContactForm, serviceInfo: nextServiceInfo } = nextProps;
        if (nextProps.isTransactApp) {
            this.handleTransactCheckout(nextProps);
        }
        if (nextAppInfo && currentAppInfo && nextAppInfo.detailInformation && currentAppInfo.detailInformation !== nextAppInfo.detailInformation) {
            this.setState({
                appPrivacyPolicyUrl: nextAppInfo.detailInformation.PrivacyPolicyUrl
            });
        }
        if (!(currentAppInfo === null || currentAppInfo === void 0 ? void 0 : currentAppInfo.pricingInformation) && (nextAppInfo === null || nextAppInfo === void 0 ? void 0 : nextAppInfo.pricingInformation)) {
            this.setState({
                loadingPricing: false
            });
        }
        if ((currentAppInfo === null || currentAppInfo === void 0 ? void 0 : currentAppInfo.pricingInformation) !== (nextAppInfo === null || nextAppInfo === void 0 ? void 0 : nextAppInfo.pricingInformation)) {
            var _nextAppInfo_pricingInformation_skus_, _nextAppInfo_pricingInformation_skus, _nextAppInfo_pricingInformation;
            this.setState({
                selectedPlanId: nextAppInfo === null || nextAppInfo === void 0 ? void 0 : (_nextAppInfo_pricingInformation = nextAppInfo.pricingInformation) === null || _nextAppInfo_pricingInformation === void 0 ? void 0 : (_nextAppInfo_pricingInformation_skus = _nextAppInfo_pricingInformation.skus) === null || _nextAppInfo_pricingInformation_skus === void 0 ? void 0 : (_nextAppInfo_pricingInformation_skus_ = _nextAppInfo_pricingInformation_skus[0]) === null || _nextAppInfo_pricingInformation_skus_ === void 0 ? void 0 : _nextAppInfo_pricingInformation_skus_.id
            });
        }
        if (nextUserProfile.firstName !== '' && currentUserProfile.firstName === '' || nextUserProfile.lastName !== '' && currentUserProfile.lastName === '' || nextUserProfile.company !== '' && currentUserProfile.company === '' || nextUserProfile.country !== '' && currentUserProfile.country === '' || nextUserProfile.email !== '' && currentUserProfile.email === '' || nextUserProfile.phone !== '' && currentUserProfile.phone === '' || nextUserProfile.title !== '' && currentUserProfile.title === '') {
            this.setAccountInfo(nextProps);
        }
        if (!nextUserInfo.loading) {
            if (this.shouldSkipModal(nextUserProfile) && !this.shouldSkipModal(currentUserProfile)) {
                this.logConsentDialogEvents(Constants.Telemetry.ActionModifier.ConsentModal, Constants.Telemetry.Action.Skip, JSON.stringify({
                    AutomaticallyAccepted: true
                }));
                this.setState({
                    shouldSkipModal: true
                });
                this.handleContinue(nextUserProfile);
            } else if (this.isCTAShouldSkipModal() && !this.isMandatoryFieldsFilled(nextUserProfile)) {
                this.logConsentDialogEvents(Constants.Telemetry.ActionModifier.ConsentModal, Constants.Telemetry.Action.Open, JSON.stringify({
                    AutomaticallyAccepted: false
                }));
            }
        }
        if (!nextIsLoadingUserProfile && currentIsLoadingUserProfile !== nextIsLoadingUserProfile) {
            this.userProfilePostLoadingActions(nextUserProfile, nextIsContactForm, nextServiceInfo);
        }
    }
    userProfilePostLoadingActions(userProfile, isContactForm, serviceInfo) {
        this.setState({
            forceUserProfileCompacted: !isContactForm && !serviceInfo && this.isMandatoryFieldsFilled(userProfile)
        });
        if (!this.isCTAShouldSkipModal()) {
            this.setState({
                showAnimation: false
            });
        }
    }
    handleTransactCheckout(props) {
        const { userInfo, modal, dismissModal, appInfo: { entityId } = {} } = props;
        this.logConsentDialogEvents(Constants.Telemetry.Action.Open, Constants.Telemetry.ActionModifier.HandleTransactCheckout, JSON.stringify({
            tenantType: userInfo.tenantType
        }));
        if (userInfo && userInfo.signedIn && !userInfo.isMSAUser && userInfo.tenantType !== Constants.TenantType.Msa) {
            var _modal_options;
            this.logConsentDialogEvents(Constants.Telemetry.Action.Redirecting, Constants.Telemetry.ActionModifier.HandleTransactCheckout, 'Redirecting to checkout page');
            urlPush(this.context.buildHref(routes.checkout, {
                entityId
            }, {
                [Constants.Checkout.DefaultPlanIdQueryParam]: modal === null || modal === void 0 ? void 0 : (_modal_options = modal.options) === null || _modal_options === void 0 ? void 0 : _modal_options.planId
            }, true, false, true));
            dismissModal();
        } else {
            this.logConsentDialogEvents(Constants.Telemetry.Action.Error, Constants.Telemetry.ActionModifier.HandleTransactCheckout, JSON.stringify({
                tenantType: userInfo.tenantType,
                isMSAUser: userInfo.isMSAUser,
                isSignedIn: userInfo.signedIn
            }));
            this.setState({
                showUserSignInError: true
            });
        }
    }
    updateUserLicenseInState() {
        const { updateLicense } = this.props;
        const { localLicenseStore } = this.state;
        updateLicense(this.licenseType, localLicenseStore);
    }
    shouldProcessLead() {
        var _getProductByUrlKey;
        const { isEmbedded, embedHost } = this.props;
        const productShouldntGenerateLead = offerTypesWithoutLeads.includes((_getProductByUrlKey = getProductByUrlKey({
            urlKey: embedHost
        })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey);
        if (isEmbedded && productShouldntGenerateLead) {
            return false;
        }
        return true;
    }
    shouldProcessLeadInfo() {
        const { appInfo, serviceInfo, flightCodes, embedHost, userInfo, isEmbedded } = this.props;
        const isService = !!serviceInfo;
        const uniqueProductId = isService ? serviceInfo.entityId : appInfo === null || appInfo === void 0 ? void 0 : appInfo.entityId;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.signedIn)) {
            this.telemetry(Constants.Telemetry.Action.ProcessLeadInfo, Constants.Telemetry.ActionModifier.Skip, {
                reason: Constants.Telemetry.LeadsDropReason.UserNotSignedIn,
                uniqueProductId,
                isEmbedded,
                embedHost
            });
            return false;
        }
        if (flightCodes) {
            this.telemetry(Constants.Telemetry.Action.ProcessLeadInfo, Constants.Telemetry.ActionModifier.Skip, {
                reason: Constants.Telemetry.LeadsDropReason.PreviewOffer,
                uniqueProductId,
                isEmbedded,
                embedHost
            });
            return false;
        }
        if (!isService) {
            if (!appInfo || appInfo.privateApp === true) {
                this.telemetry(Constants.Telemetry.Action.ProcessLeadInfo, Constants.Telemetry.ActionModifier.Skip, {
                    reason: Constants.Telemetry.LeadsDropReason.AppNotAvailableOrPrivate,
                    uniqueProductId,
                    isEmbedded,
                    embedHost
                });
                return false;
            }
        }
        if (!this.shouldProcessLead()) {
            this.telemetry(Constants.Telemetry.Action.ProcessLeadInfo, Constants.Telemetry.ActionModifier.Skip, {
                reason: Constants.Telemetry.LeadsDropReason.EmbedWithoutLead,
                uniqueProductId,
                isEmbedded,
                embedHost
            });
            return false;
        }
        return true;
    }
    processLeadInfo() {
        var _this = this;
        return _async_to_generator(function*() {
            const { ctaType, appInfo, sendLeadInfo, isContactForm, serviceInfo, isEmbedded, embedHost } = _this.props;
            const { notes } = _this.state;
            const isService = !!serviceInfo;
            const item = isService ? serviceInfo : appInfo;
            try {
                _this.telemetry(Constants.Telemetry.Action.ProcessLeadInfo, Constants.Telemetry.ActionModifier.Start, {
                    data: `Processing the lead. isService is ${isService}.`,
                    uniqueProductId: item.entityId,
                    isEmbedded,
                    embedHost
                });
                if (_this.shouldProcessLeadInfo()) {
                    yield sendLeadInfo({
                        item,
                        ctaType,
                        notes
                    });
                    _this.telemetry(Constants.Telemetry.Action.ProcessLeadInfo, Constants.Telemetry.ActionModifier.End, {
                        uniqueProductId: item.entityId,
                        isEmbedded,
                        embedHost
                    });
                }
            } catch (error) {
                const shouldStopFlow = isContactForm || isService;
                _this.telemetry(Constants.Telemetry.Action.ProcessLeadInfo, Constants.Telemetry.ActionModifier.Error, {
                    error,
                    shouldStopFlow,
                    uniqueProductId: item.entityId,
                    isEmbedded,
                    embedHost
                });
                if (shouldStopFlow) {
                    throw error;
                }
            }
        })();
    }
    handleContinueHelper(showAnimation = true, shouldGenerateLead = true) {
        const { getUserAuthStatus, serviceInfo, isContactForm, ctaType, isEmbedded, appInfo, embedHost, dismissModal, signOutUser, featureFlags } = this.props;
        const { isEmbeddedApp } = this.state;
        if (this.licenseType && this.licenseType !== -1) {
            this.updateUserLicenseInState();
        }
        var _this = this;
        getUserAuthStatus().then(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function*(result) {
                if (isEmbeddedApp || result.status !== Constants.SigninStatus.ExpiredTokenInvalidCookie) {
                    try {
                        var _appInfo_pricingInformation_skus_find, _appInfo_pricingInformation_skus, _appInfo_pricingInformation;
                        _this.setState({
                            showAnimation: true
                        });
                        const selectedPlanHandoffURL = updateHandOffUrlWithCampaignParams(appInfo === null || appInfo === void 0 ? void 0 : (_appInfo_pricingInformation = appInfo.pricingInformation) === null || _appInfo_pricingInformation === void 0 ? void 0 : (_appInfo_pricingInformation_skus = _appInfo_pricingInformation.skus) === null || _appInfo_pricingInformation_skus === void 0 ? void 0 : (_appInfo_pricingInformation_skus_find = _appInfo_pricingInformation_skus.find(({ id })=>id === _this.state.selectedPlanId)) === null || _appInfo_pricingInformation_skus_find === void 0 ? void 0 : _appInfo_pricingInformation_skus_find.handoffURL);
                        const url = selectedPlanHandoffURL || getHandoffUrl(appInfo);
                        const actions = [
                            _this.processLeadInfo()
                        ];
                        yield Promise.all(actions);
                        _this.setState({
                            showAnimation: false
                        });
                        if (serviceInfo || isContactForm) {
                            _this.setState({
                                showSuccessDialog: true
                            });
                        }
                        if (!shouldGenerateLead) {
                            _this.logConsentDialogEvents(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.CTAInfo, 'User choose not to generate lead');
                        }
                        if (isEmbedded && !isContactForm) {
                            // TODO : Publish lead in embed experience using the host data
                            // We need to fetch lastName, firstName and email. If firstName/lastName are null, use FNU/LNU
                            postEmbedAcquisitionMessage(appInfo, ctaType, embedHost);
                            setTimeout(()=>{
                                dismissModal();
                            }, 1000);
                            return;
                        }
                        if (!isContactForm && !serviceInfo) {
                            var _getNpsModule;
                            if (shouldDownloadPowerBIVisual(appInfo, isEmbedded)) {
                                _this.handlePowerBIVisualDownload();
                                return;
                            }
                            _this.logOutgoingHandoffRedirect(url);
                            if (!url) {
                                dismissModal();
                                return;
                            }
                            NpsModule.IncreaseAppAcquisition();
                            (_getNpsModule = getNpsModule()) === null || _getNpsModule === void 0 ? void 0 : _getNpsModule.ctaClicked(false);
                            if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.openInNewWindowButton) {
                                if (showAnimation) {
                                    _this.setState({
                                        showAnimation: true,
                                        handoffUrl: url
                                    });
                                    dismissModal();
                                }
                                openInNewWindow(url);
                            } else {
                                if (showAnimation) {
                                    _this.setState({
                                        showAnimation: true,
                                        handoffUrl: url
                                    });
                                    setTimeout(function() {
                                        window.open(url, '_self');
                                    }, 2500);
                                } else {
                                    window.open(url, '_self');
                                }
                            }
                        }
                    } catch (error) {
                        const errorString = stringifyError(error);
                        const actionModifier = isContactForm ? Constants.Telemetry.ActionModifier.SubmitLeadGen : Constants.Telemetry.ActionModifier.ConsentModal;
                        const action = errorString === Constants.Telemetry.Action.RefreshToken ? Constants.Telemetry.Action.RefreshToken : Constants.Telemetry.Action.Error;
                        _this.logConsentDialogEvents(action, actionModifier, errorString);
                        if (errorString === Constants.Telemetry.Action.RefreshToken) {
                            signOutUser();
                        }
                        if (isContactForm || serviceInfo) {
                            _this.setState({
                                showContactMeError: true,
                                showAnimation: false
                            });
                        } else {
                            _this.setState({
                                showAnimation: false
                            });
                        }
                    }
                }
            });
            return function(result) {
                return _ref.apply(this, arguments);
            };
        }());
    }
    hideAccountInfoUI() {
        const { forceUserProfileCompacted } = this.state;
        if (forceUserProfileCompacted) {
            this.setState({
                forceUserProfileCompacted: false
            });
        }
        this.setState({
            showAccountInfo: true
        });
    }
    onUpdateAccountInfo(key, value) {
        this.setState({
            accountInfo: this.updateAccountInfo(key, value)
        });
    }
    updateAccountInfo(key, value) {
        const { accountInfo } = this.state;
        const newAccountInfo = {
            firstName: accountInfo.firstName,
            lastName: accountInfo.lastName,
            email: accountInfo.email,
            title: accountInfo.title,
            company: accountInfo.company,
            country: accountInfo.country,
            phone: accountInfo.phone
        };
        newAccountInfo[`${key}`] = value;
        return newAccountInfo;
    }
    handlePowerBIVisualDownload() {
        const { appInfo, location, openInstructionsModal, dismissModal } = this.props;
        if (appInfo === null || appInfo === void 0 ? void 0 : appInfo.downloadLink) {
            const payload = {
                page: location.pathname,
                action: Constants.Telemetry.Action.Click,
                actionModifier: Constants.Telemetry.ActionModifier.DownloadPBIVisual,
                appName: appInfo.entityId
            };
            this.instrument.probe(Constants.Telemetry.ProbeName.LogInfo, payload);
            logger.info('', {
                action: payload.action,
                actionModifier: payload.actionModifier,
                appName: payload.appName
            });
            window.location.href = appInfo.downloadLink;
            if (!getLocalStorageItem(Constants.LocalStorage.dontShowInstructions)) {
                openInstructionsModal();
            } else {
                dismissModal();
            }
        }
    }
    handleContinue(userProfile, showAnimation = true, shouldGenerateLead = true) {
        const { isEmbeddedApp } = this.state;
        const { query, updatePurchaseStatus, isContactForm, appInfo, serviceInfo } = this.props;
        const { entityId } = appInfo || serviceInfo;
        const shouldGenerateLeadGen = shouldGenerateLead && !isETERunning(query);
        getTrailIdAndData(true, 'consent form - continue btn');
        if (!isEmbeddedApp && !this.shouldSkipModal(userProfile)) {
            const actionModifier = isContactForm ? Constants.Telemetry.ActionModifier.SubmitLeadGen : Constants.Telemetry.ActionModifier.ConsentModal;
            this.logConsentDialogEvents(Constants.Telemetry.Action.Click, actionModifier);
            this.logConsentTelemetry({
                contentId: Constants.JsllCTAId.Continue,
                areaName: Constants.Telemetry.AreaName.ConsentModal,
                entityId
            });
            this.setState({
                formSubmitted: true
            });
        } else {
            this.logConsentTelemetry({
                contentId: Constants.Telemetry.ContentType.SkipConsentModal,
                areaName: Constants.Telemetry.AreaName.ConsentModal,
                entityId
            });
            this.handleContinueHelper(showAnimation, shouldGenerateLeadGen);
        }
        updatePurchaseStatus();
    }
    logConsentTelemetry({ contentId, areaName, entityId }) {
        pageAction(null, {
            content: {
                contentId,
                areaName,
                contentName: entityId
            }
        });
    }
    getTelemetryDetailsContent() {
        const { trailId } = this.state;
        const { appInfo, serviceInfo, isContactForm, isNationalCloud, ctaType, currentView } = this.props;
        const { shouldSkipModal } = this.state;
        const entityInfo = appInfo || serviceInfo;
        const hasCheckbox = !isContactForm;
        const hasUserProfile = !shouldSkipModal || !!serviceInfo;
        // application
        if (appInfo) {
            return getAppTelemetryDetailContentText({
                appInfo: entityInfo,
                isNationalCloud,
                ctaTypes: [
                    ctaType
                ],
                consentDialogHasUserProfile: hasUserProfile,
                consentDialogHasCheckbox: hasCheckbox,
                currentView,
                trailId
            });
        }
        // consulting services
        return getServiceTelemetryDetailContentText({
            serviceInfo: entityInfo,
            isNationalCloud,
            ctaTypes: [
                ctaType
            ],
            consentDialogHasUserProfile: hasUserProfile,
            consentDialogHasCheckbox: hasCheckbox,
            currentView,
            trailId
        });
    }
    profileCompleted(profileFilledOut) {
        const { isProfileCompleted } = this.state;
        if (isProfileCompleted !== profileFilledOut) {
            this.setState({
                isProfileCompleted: profileFilledOut
            });
        }
    }
    disableSubmitButton() {
        const { showUserSignInError, shouldSkipModal, isProfileCompleted, isNotesInvalid } = this.state;
        const { isContactForm } = this.props;
        if (showUserSignInError) {
            return false;
        }
        if (!shouldSkipModal) {
            return !isProfileCompleted || isContactForm && isNotesInvalid;
        }
        return isLeadgenEnabled();
    }
    getTermsLink() {
        const { appInfo } = this.props;
        const terms = {};
        if (appInfo === null || appInfo === void 0 ? void 0 : appInfo.UsesEnterpriseContract) {
            terms.link = Constants.enterpriseContractLink;
            terms.locKey = 'ECA_Link';
            return terms;
        }
        terms.link = appInfo.licenseTermsUrl;
        terms.locKey = 'TRY_Terms2';
        return terms;
    }
    renderConsentDisclaimer() {
        const { ctaType, isContactForm, appInfo } = this.props;
        const terms = appInfo && this.getTermsLink();
        const { appPrivacyPolicyUrl } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                tokens: desclaimerTokens,
                className: consentModalClassNames.desclaimerContainer,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: "info",
                        styles: infoIconStyles
                    }),
                    isContactForm ? /*#__PURE__*/ _jsx(SafeHtmlWrapper, {
                        html: this.context.locParams('Contact_Me_Consent_Disclaimer', [
                            `<a href='${Constants.MicrosoftTermsURL}' rel='noreferrer' target='_blank'>${this.context.loc('RT_Terms', 'terms')}</a>`
                        ])
                    }) : appInfo ? /*#__PURE__*/ _jsx(SafeHtmlWrapper, {
                        html: this.context.locParams('App_Consent_Disclaimer', [
                            `<b>${this.context.loc(getActionStringForCTAType(ctaType))}</b>`,
                            `<a href='${terms.link}' rel='noreferrer' target='_blank'>${this.context.loc('Provider_Terms', 'terms of use')}</a>`,
                            `<a href='${appPrivacyPolicyUrl}' rel='noreferrer' target='_blank'>${this.context.loc('TRY_PrivacyPolicy', 'privacy policy')}</a>`,
                            `<a href='${Constants.MicrosoftTermsURL}' rel='noreferrer' target='_blank'>${this.context.loc('TRY_Terms', 'terms')}</a>`,
                            `<a href='${Constants.MicrosoftPrivacyStatementURL}' rel='noreferrer' target='_blank'>${this.context.loc('TRY_Privacy', 'privacy')}</a>`
                        ])
                    }) : /*#__PURE__*/ _jsx(SafeHtmlWrapper, {
                        html: this.context.locParams('CS_Consent_Disclaimer', [
                            `<a href='${Constants.MicrosoftTermsURL}' rel='noreferrer' target='_blank'>${this.context.loc('TRY_Terms', 'terms')}</a>`,
                            `<a href='${Constants.MicrosoftPrivacyStatementURL}' rel='noreferrer' target='_blank'>${this.context.loc('TRY_Privacy', 'privacy')}</a>`
                        ])
                    })
                ]
            })
        });
    }
    renderConsentBottomBar() {
        const { appInfo, isContactForm, isEmbedded, billingCountryCode, ctaType, serviceInfo, dismissModal, userProfile, isLoadingUserProfile } = this.props;
        const { showUserSignInError, isEmbeddedApp } = this.state;
        let ctaButton;
        const isCTADisabled = !isEmbeddedApp && (this.disableSubmitButton() || isLoadingUserProfile);
        if (isContactForm || !!serviceInfo) {
            ctaButton = /*#__PURE__*/ _jsx(PrimaryButton, {
                name: "button",
                text: this.context.loc('CTA_ContactMe', 'Contact me'),
                type: "submit",
                "data-bi-id": Constants.JsllCTAId.Continue,
                "data-bi-name": appInfo === null || appInfo === void 0 ? void 0 : appInfo.entityId,
                "data-bi-type": (appInfo === null || appInfo === void 0 ? void 0 : appInfo.offerType) === OfferType.SaaSApp ? isTransactApp({
                    isEmbedded,
                    ctaTypes: appInfo.ctaTypes,
                    appData: appInfo,
                    billingRegion: billingCountryCode
                }) ? Constants.JsllSaas.SaasTransactable : Constants.JsllSaas.SaasNonTransactable : '',
                "data-bi-area": "Consent Dialog",
                onClick: ()=>this.handleContinue(userProfile),
                disabled: isCTADisabled
            });
        } else {
            var _this_props_featureFlags;
            const url = getHandoffUrl(appInfo);
            const isOpenInNewWindow = ((_this_props_featureFlags = this.props.featureFlags) === null || _this_props_featureFlags === void 0 ? void 0 : _this_props_featureFlags.openInNewWindowButton) && isOpenInNewWindowButton({
                isEmbedded,
                ctaType,
                appData: appInfo,
                billingRegion: billingCountryCode,
                url
            });
            const isPBIVisualPriceHidden = hidePowerBiVisualPricing({
                app: appInfo,
                isEmbedded
            });
            ctaButton = /*#__PURE__*/ _jsx(PrimaryButton, {
                className: classNames({
                    [openInNewWindowButtonStyles.openInNewWindowButton]: isOpenInNewWindow
                }),
                text: isPBIVisualPriceHidden && ctaType === Constants.CTAType.Install ? this.context.loc('CTA_Install_free', 'Install free') : this.context.loc(getActionStringForCTAType(ctaType)),
                name: "button",
                type: "submit",
                "data-bi-id": Constants.JsllCTAId.Continue,
                "data-bi-name": appInfo === null || appInfo === void 0 ? void 0 : appInfo.entityId,
                "data-bi-type": (appInfo === null || appInfo === void 0 ? void 0 : appInfo.offerType) === OfferType.SaaSApp ? isTransactApp({
                    isEmbedded,
                    ctaTypes: appInfo.ctaTypes,
                    appData: appInfo,
                    billingRegion: billingCountryCode
                }) ? Constants.JsllSaas.SaasTransactable : Constants.JsllSaas.SaasNonTransactable : '',
                "data-bi-area": "Consent Dialog",
                onClick: ()=>showUserSignInError ? dismissModal() : this.handleContinue(userProfile),
                disabled: isCTADisabled,
                iconProps: isOpenInNewWindow ? {
                    iconName: 'OpenInNewWindow'
                } : {}
            });
        }
        return /*#__PURE__*/ _jsx(Stack.Item, {
            align: "end",
            children: getTooltipSilentLogIn(ctaButton, isLoadingUserProfile)
        });
    }
    renderUserProfileModal() {
        const { isEmbedded, isContactForm } = this.props;
        const { formSubmitted, localLicenseStore, forceUserProfileCompacted, shouldSkipModal } = this.state;
        return !shouldSkipModal && /*#__PURE__*/ _jsx(Stack, {
            className: consentModalClassNames.userProfileContainer,
            children: /*#__PURE__*/ _jsx(UserProfileModal, {
                isEmbedded: isEmbedded,
                userSubmittedForm: formSubmitted,
                profileCompleted: this.profileCompleted.bind(this),
                callBackHandler: this.handleContinueHelper.bind(this),
                shouldHideAccountInfo: this.hideAccountInfoUI.bind(this),
                licenseType: this.licenseType,
                currentLicense: localLicenseStore,
                compactUserProfile: forceUserProfileCompacted,
                accountInfoUpdate: this.onUpdateAccountInfo.bind(this),
                shouldRenderHeader: true,
                isContactForm: isContactForm
            })
        });
    }
    renderNotes() {
        const { notes, isNotesInvalid } = this.state;
        const { isContactForm } = this.props;
        return isContactForm && /*#__PURE__*/ _jsx(TextField, {
            className: consentModalClassNames.notes,
            multiline: true,
            rows: 4,
            maxLength: 1500,
            deferredValidationTime: 2000,
            errorMessage: isNotesInvalid ? this.context.loc('ConsentModal_Notes_ContainEmailOrUrlErrorMsg', "This field can't contain URLs or email addresses.") : '',
            label: this.context.loc('ConsentModal_Notes_Label', 'Describe your use case'),
            placeholder: this.context.loc('ConsentModal_Notes_Placeholder', 'Tell us about your team’s business needs.\nFor example, are you working on a current project? What is your time frame?'),
            value: notes,
            onChange: this.onNotesChange
        });
    }
    renderLoginInfo() {
        const { userInfo } = this.props;
        const { displayName, email } = userInfo;
        return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.signedIn) && /*#__PURE__*/ _jsx(Stack, {
            tokens: loginUserInfoTokens,
            children: /*#__PURE__*/ _jsxs(Text, {
                variant: "medium",
                children: [
                    this.context.loc('Leads_Logged_User_Info', "You're signed in as"),
                    ' ',
                    /*#__PURE__*/ _jsxs(Text, {
                        variant: "medium",
                        className: consentModalClassNames.boldText,
                        children: [
                            displayName,
                            " (",
                            email,
                            ")."
                        ]
                    })
                ]
            })
        });
    }
    renderConsentElement() {
        var _appInfo_pricingInformation;
        const { appInfo, serviceInfo, locale, billingCountryCode } = this.props;
        const { isEmbeddedApp, selectedPlanId } = this.state;
        const iconSrc = appInfo ? appInfo.iconURL : serviceInfo.extraData.smallIconUri;
        const title = appInfo ? appInfo.title : serviceInfo.title;
        const publisher = appInfo ? appInfo.publisher : serviceInfo.publisher;
        return /*#__PURE__*/ _jsxs(Stack, {
            children: [
                /*#__PURE__*/ _jsxs(Stack, {
                    horizontal: true,
                    children: [
                        /*#__PURE__*/ _jsx(Stack.Item, {
                            align: "center",
                            children: /*#__PURE__*/ _jsx(TelemetryImage, {
                                imgClassName: consentModalClassNames.appImg,
                                className: classNames(consentModalClassNames.appImgContainer, {
                                    'ms-depth-8': true
                                }),
                                src: iconSrc,
                                "aria-label": this.context.loc('Telemetry_Image_Aria_Label', 'Application Icon'),
                                alt: title
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Stack, {
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    variant: "mediumPlus",
                                    className: consentModalClassNames.boldText,
                                    children: title
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    variant: "medium",
                                    children: this.context.locParams('Tile_By', [
                                        publisher
                                    ])
                                })
                            ]
                        })
                    ]
                }),
                !isEmbeddedApp && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ConsentModalPlan, {
                            plans: appInfo === null || appInfo === void 0 ? void 0 : (_appInfo_pricingInformation = appInfo.pricingInformation) === null || _appInfo_pricingInformation === void 0 ? void 0 : _appInfo_pricingInformation.skus,
                            selectedPlanId: selectedPlanId,
                            countryCode: billingCountryCode,
                            locale: locale,
                            onPlanChange: (selectedPlanId)=>this.setState({
                                    selectedPlanId
                                })
                        }),
                        this.renderLoginInfo(),
                        this.renderUserProfileModal(),
                        this.renderNotes()
                    ]
                }),
                this.renderConsentDisclaimer(),
                this.renderConsentBottomBar()
            ]
        });
    }
    switchToleadGen() {
        this.setState({
            showAnimation: false
        });
        return this.renderConsentElement();
    }
    renderImpl() {
        const { dismissModal, isTransactApp, isContactForm, appInfo, serviceInfo } = this.props;
        const { shouldSkipModal, showSuccessDialog, showUserSignInError, showAnimation, showContactMeError } = this.state;
        const publisher = appInfo ? appInfo.publisher : serviceInfo.publisher;
        if (shouldSkipModal && this.isCTAShouldSkipModal()) {
            this.setState({
                shouldSkipModal: false
            });
        }
        return showSuccessDialog && (isContactForm || serviceInfo) ? /*#__PURE__*/ _jsx(SuccessConsentModal, {
            dismissModal: dismissModal,
            publisher: publisher,
            shouldSkipModal: shouldSkipModal
        }) : (showUserSignInError || showContactMeError) && (isContactForm || serviceInfo) ? /*#__PURE__*/ _jsx(FailureConsentModal, {
            dismissModal: dismissModal,
            shouldSkipModal: shouldSkipModal,
            showContactMeError: showContactMeError
        }) : /*#__PURE__*/ _jsx(ConsentModalContent, {
            showAnimation: showAnimation,
            handoffTitle: getHandoffTitle(appInfo),
            isTransactApp: isTransactApp,
            isContactForm: isContactForm || !!serviceInfo,
            shouldSkipModal: shouldSkipModal,
            publisher: appInfo ? appInfo.publisher : serviceInfo.publisher,
            dismissModal: dismissModal,
            children: this.renderPromptContent()
        });
    }
    renderPromptContent() {
        const { showAnimation, loadingPricing } = this.state;
        const { appInfo, serviceInfo } = this.props;
        if (showAnimation || loadingPricing) {
            return this.renderAnimation();
        }
        if (appInfo || serviceInfo) {
            return this.renderApp();
        }
    }
    renderAnimation() {
        const { appInfo, serviceInfo } = this.props;
        const iconSrc = appInfo ? appInfo.iconURL : serviceInfo.extraData.smallIconUri;
        const title = appInfo ? appInfo.title : serviceInfo.title;
        const { animationImg, appImg, appImgContainer } = consentModalClassNames;
        return /*#__PURE__*/ _jsxs(Stack, {
            tokens: animationStackTokens,
            children: [
                /*#__PURE__*/ _jsx(Stack.Item, {
                    children: /*#__PURE__*/ _jsx(Animation, {})
                }),
                /*#__PURE__*/ _jsx(Stack.Item, {
                    className: animationImg,
                    children: /*#__PURE__*/ _jsx(TelemetryImage, {
                        imgClassName: appImg,
                        className: classNames(appImgContainer, {
                            'ms-depth-8': true
                        }),
                        src: iconSrc,
                        "aria-label": this.context.loc('Telemetry_Image_Aria_Label', 'Application Icon'),
                        alt: title
                    })
                })
            ]
        });
    }
    renderApp() {
        const { isTransactApp, userInfo } = this.props;
        const leadGen = isTransactApp && (userInfo.isMSAUser || userInfo.tenantType && userInfo.tenantType !== Constants.TenantType.Managed);
        return leadGen ? this.switchToleadGen() : this.renderConsentElement();
    }
    constructor(props){
        var _appInfo_pricingInformation_skus_, _appInfo_pricingInformation_skus, _appInfo_pricingInformation;
        super(props), _define_property(this, "context", void 0), _define_property(this, "instrument", void 0), _define_property(this, "licenseType", -1), _define_property(this, "logOutgoingHandoffRedirect", (url)=>{
            const { appInfo, serviceInfo, location } = this.props;
            const entityInfo = appInfo || serviceInfo;
            const payload = {
                page: location.pathname,
                action: Constants.Telemetry.Action.Redirecting,
                actionModifier: Constants.Telemetry.ActionModifier.OfficeOffersPurchase,
                appName: entityInfo && entityInfo.entityId,
                details: url
            };
            this.instrument.probe('logAndFlushTelemetryInfo', payload);
            logger.info(payload.details, {
                action: payload.action,
                actionModifier: payload.actionModifier,
                appName: payload.appName
            });
        }), _define_property(this, "onNotesChange", (event, newValue)=>{
            this.setState({
                notes: newValue,
                isNotesInvalid: containsURLOrEmail(newValue)
            });
        });
        this.instrument = SpzaInstrumentService.getProvider();
        const { userProfile, isContactForm, serviceInfo, isEmbedded, appInfo } = this.props;
        // 1 is D365 license, 2 is D365 for financial license, -1 is don't display account info
        this.licenseType = isEmbedded ? dynamicsLicenseTypeForEmbed(appInfo.products) : appInfo ? dynamicsLicenseType(userProfile, appInfo.products) : -1;
        this.state = {
            loadingPricing: false,
            isProfileCompleted: false,
            showAnimation: false,
            showUserSignInError: false,
            showContactMeError: false,
            // To get the privacy URL for an app, we need to fetch the App Details. This is lazy loaded.
            // Hence it is in the state.
            appPrivacyPolicyUrl: '',
            showSuccessDialog: false,
            formSubmitted: false,
            showAccountInfo: false,
            forceUserProfileCompacted: !isContactForm && !serviceInfo && this.isMandatoryFieldsFilled(userProfile),
            accountInfo: {
                firstName: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.firstName) ? userProfile.firstName : '',
                lastName: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.lastName) ? userProfile.lastName : '',
                email: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.email) ? userProfile.email : '',
                title: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.title) ? userProfile.title : '',
                company: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.company) ? userProfile.company : '',
                country: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.country) ? userProfile.country : '',
                phone: (userProfile === null || userProfile === void 0 ? void 0 : userProfile.phone) ? userProfile.phone : ''
            },
            notes: '',
            isNotesInvalid: false,
            localLicenseStore: (this.licenseType === Constants.Dynamics365LicenseType.dynamics365License || this.licenseType === Constants.Dynamics365LicenseType.dynamics365forBusinessLicense) && !isEmbedded ? setInitialLocalLicenseStore(userProfile.licenses, this.licenseType) : null,
            licenseDisplayText: (this.licenseType === Constants.Dynamics365LicenseType.dynamics365License || this.licenseType === Constants.Dynamics365LicenseType.dynamics365forBusinessLicense) && !isEmbedded ? setInitialLicenseDisplayText(userProfile.licenses, this.licenseType) : '',
            shouldSkipModal: this.shouldSkipModal(userProfile),
            trailId: generateGuid(),
            selectedPlanId: appInfo === null || appInfo === void 0 ? void 0 : (_appInfo_pricingInformation = appInfo.pricingInformation) === null || _appInfo_pricingInformation === void 0 ? void 0 : (_appInfo_pricingInformation_skus = _appInfo_pricingInformation.skus) === null || _appInfo_pricingInformation_skus === void 0 ? void 0 : (_appInfo_pricingInformation_skus_ = _appInfo_pricingInformation_skus[0]) === null || _appInfo_pricingInformation_skus_ === void 0 ? void 0 : _appInfo_pricingInformation_skus_.id
        };
        const { accountInfo } = this.state;
        if (isEmbedded && accountInfo.firstName === '' && accountInfo.lastName === '' && accountInfo.email === '' && accountInfo.phone === '') {
            const userProfileInCookie = getCookieItem(Constants.userProfileEmbedCookieName, false);
            if (userProfileInCookie) {
                const userInfoInCache = {
                    firstName: '',
                    lastName: '',
                    phone: '',
                    company: '',
                    country: '',
                    email: '',
                    title: '',
                    accepted: true,
                    managedLicenses: []
                };
                readUserProfileEmbedCookie(userProfileInCookie, userInfoInCache);
                const accountInfoFromCache = {
                    firstName: userInfoInCache.firstName ? userInfoInCache.firstName : '',
                    lastName: userInfoInCache.lastName ? userInfoInCache.lastName : '',
                    email: userInfoInCache.email ? userInfoInCache.email : '',
                    title: userInfoInCache.title ? userInfoInCache.title : '',
                    company: userInfoInCache.company ? userInfoInCache.company : '',
                    country: userInfoInCache.country ? userInfoInCache.country : '',
                    phone: userInfoInCache.phone ? userInfoInCache.phone : ''
                };
                this.state = {
                    accountInfo: accountInfoFromCache
                };
            }
        }
    }
}
ConsentModal.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func,
    buildHref: PropTypes.func
};
